// extracted by mini-css-extract-plugin
export default {"circularCards":"circularCard_circularCards__hYh-o","circularCardTitle":"circularCard_circularCardTitle__IflCA"};